export enum avatarType {
    individual = 'individual',
    user = 'user',
    organization = 'organization',
    externalContact = 'externalContact',
    stamp = 'stamp'
}

